module.exports = __webpack_public_path__ + "static/media/flik.eaa6b711.png";